import {
  CustomerFieldConfig,
  CustomerForm,
  CustomerSelectOption,
} from "./types";

export const CATEGORY_OPTIONS: CustomerSelectOption[] = [
  {
    value: "רמה 1 / צי רכב",
    labelKey: "CUSTOMERS.DATA.CUSTOMER_1.CATEGORY",
  },
  {
    value: "תעשייה",
    labelKey: "CUSTOMERS.DATA.CUSTOMER_2.CATEGORY",
  },
  {
    value: "ממשלתי / חצי-ממשלתי",
    labelKey: "CUSTOMERS.DATA.CUSTOMER_3.CATEGORY",
  },
];

export const ADD_CUSTOMER_FIELDS: CustomerFieldConfig[] = [
  { key: "customerName", label: "CUSTOMER_NAME", type: "text" },
  {
    key: "category",
    label: "CATEGORY",
    type: "select",
    options: CATEGORY_OPTIONS,
  },
  { key: "contactPerson", label: "CONTACT_PERSON", type: "text" },
  {
    key: "contactPhone",
    label: "CONTACT_PHONE",
    type: "text",
    placeholder: "PHONE_MASK",
  },
  { key: "contactEmail", label: "CONTACT_EMAIL", type: "text" },
];

export const REQUIRED_CUSTOMER_FIELDS: Array<keyof CustomerForm> = [
  "customerName",
  "category",
  "contactPerson",
  "contactPhone",
  "contactEmail",
];
